import React, { useEffect } from "react";
import Loading from "../shared/Loading";
import { connect } from "react-redux";
import { getOrderDetail } from "../../redux/actions/OrderActions";
import { Redirect } from "react-router-dom";
import LoaderHOC from "../shared/LayoutHOC";
import useWindowSize from "../hooks/useWindowSize";

import mailIcon from "../../assets/images/vvns-order-tracking-mail-icon.svg";
import phoneIcon from "../../assets/images/vvns-order-tracking-phone-icon.svg";

import cargoIcon from "../../assets/images/vvns-order-tracking-cargo-icon.svg";
import vivenseCargoIcon from "../../assets/images/vvns-order-tracking-vivense-cargo-icon.svg";

const Detail = ({ data, getOrderDetail, history, ...props }) => {
  const size = useWindowSize();

  const locationParams = props.location.search;
  useEffect(() => {
    getOrderDetail(locationParams);
  }, [locationParams, getOrderDetail]);

  const togglePanelHandlder = (indexOfItem) => {
    const targetElement = `detail--${indexOfItem}`;
    const targetElementBtn = `btn-${indexOfItem}`;
    document
      .getElementsByClassName(targetElement)[0]
      .classList.toggle("item--show");
    document
      .getElementsByClassName(targetElementBtn)[0]
      .classList.toggle("open");
  };

  const {
    orderNumber,
    date,
    itemsCount,
    preparingCount,
    deliveredCount,
    customerEmail,
    customerPhoneNumber,
    cancelledDeliveryCount,
    deliveryAdress,
    invoiceAdress,
    cancelledCount,
    transferCount,
    items,
  } = data.result;

  const classByCount = (item) => {
    if (item > 0) {
      return "active";
    }
    return "passive";
  };

  const itemCountUI = (item) => {
    if (item < 1) {
      return "-";
    }
    return item;
  };

  const OrderResult = () => {
    if (data.result.status === 200) {
      return (
        <>
          <div className="pageWrapper__container__content__summary">
            <div className="pageWrapper__container__content__summary__column column--infos">
              <div className="pageWrapper__container__content__summary__column__order__number">
                <span className="title">Sipariş Numarası </span>
                <span className="content">{orderNumber}</span>
              </div>
              <div className="pageWrapper__container__content__summary__column__order__date">
                {date}
              </div>
              <div className="pageWrapper__container__content__summary__column__order__count">
                {itemsCount}
              </div>
            </div>
            <div className="pageWrapper__container__content__summary__column__two pageWrapper__container__content__summary__column_two--1">
              <div
                className={`pageWrapper__container__content__summary__column column--onTheTransaction column--onTheTransaction-1 ${classByCount(
                  preparingCount
                )}`}
              >
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__count">
                  {itemCountUI(preparingCount)}
                </div>
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__text">
                  ÜRÜNÜN HAZIRLANIYOR
                </div>
              </div>
              <div
                className={`pageWrapper__container__content__summary__column column--onTheTransaction column--onTheTransaction-2 ${classByCount(
                  transferCount
                )}`}
              >
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__count">
                  {itemCountUI(transferCount)}
                </div>
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__text">
                  ÜRÜNÜN YOLDA
                </div>
              </div>
            </div>
            <div className="pageWrapper__container__content__summary__column__two pageWrapper__container__content__summary__column_two--2">
              <div
                className={`pageWrapper__container__content__summary__column column--result column--result-1 ${classByCount(
                  deliveredCount
                )}`}
              >
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__count">
                  {itemCountUI(deliveredCount)}
                </div>

                <div className="pageWrapper__container__content__summary__column__result__text">
                  TESLİM EDİLDİ
                </div>
              </div>
              <div
                className={`pageWrapper__container__content__summary__column column--result column--result-2 ${classByCount(
                  cancelledCount
                )}`}
              >
                <div className="pageWrapper__container__content__summary__column__onTheTransaction__count">
                  {itemCountUI(cancelledCount)}
                </div>

                <div className="pageWrapper__container__content__summary__column__result__text">
                  İPTAL / İADE
                </div>
              </div>
            </div>

            <div className="pageWrapper__container__content__summary__column column--final">
              <div className="pageWrapper__container__content__summary__column__final__text">
                <p className="result_title">Sipariş Durumu </p>
                <span className="result_text">{cancelledDeliveryCount}</span>
                <span className="result_text-completed"> Tamamlandı</span>
              </div>
            </div>
          </div>
          <div className="pageWrapper__container__content__itemsWrapper">
            {items.map((object, index) => (
              <div
                key={object.itemSku + index}
                className="pageWrapper__container__content__itemsWrapper__item"
              >
                <div className="pageWrapper__container__content__itemsWrapper__item__info">
                  <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn">
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__img">
                      <img src={`${object.itemImg}`} alt={object.itemTitle} />
                    </div>
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info">
                      <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_title">
                        {object.itemTitle}
                      </div>
                      <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_sku">
                        {object.itemSku}
                      </div>
                      <div className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_count">
                        <div>
                          <span className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_count_text">
                            Adet:{" "}
                          </span>
                          <span className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_count_number">
                            &nbsp;{object.itemCount}
                          </span>
                        </div>
                        <div className="pageWrapper__product-price">
                          <span className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_count_text">
                            Fiyat:{" "}
                          </span>
                          <span className="pageWrapper__container__content__itemsWrapper__item__info__imgColumn__info_count_number">
                            {object.itemPrice} TL
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pageWrapper__deliver-date-wrapper d-lg-up-none">
                    <span className="pageWrapper__deliver-date-title">
                      Planlanan Teslimat Tarihi:
                    </span>
                    <span className="pageWrapper__deliver-date">
                      {object.latestDeliveryDueDate}
                    </span>
                  </div>
                  <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn">
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__title">
                      <img
                        src={
                          object.itemOperationType &&
                          object.itemOperationType === "Vivense Nakliye"
                            ? vivenseCargoIcon
                            : cargoIcon
                        }
                        alt="Vivense Order Tracking Mail Icon"
                      />
                      <span className="item-info__delivery-title">
                        Teslimat Türü: &nbsp;
                      </span>
                      <span className="item-info__delivery-detail">
                        {object.itemOperationType}
                      </span>
                    </div>
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__row">
                      <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__type">
                        <span>
                          {object.itemOperationType &&
                          object.itemOperationType !== "Vivense Nakliye"
                            ? object.itemDeliveryType
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__row">
                      {object.itemTrackingNumber && (
                        <>
                          <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__title">
                            Takip No: &nbsp;
                          </div>
                          <div className="pageWrapper__container__content__itemsWrapper__item__info__deliveryColumn__tracking-number">
                            {object.itemTrackingNumber}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn">
                    <div
                      className={`pageWrapper__container__content__itemsWrapper__item__info__resultColumn__state status--${object.itemStatus.statusIcon}`}
                    >
                      <div
                        className={`pageWrapper__container__content__itemsWrapper__item__info__resultColumn__state__icon status--${object.itemStatus.statusIcon}`}
                      ></div>
                      {object.itemStatus.statusTitle}
                    </div>
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn__date">
                      {object.statusDate}
                    </div>
                    {/* <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn__tracking">
                                                <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn__tracking__title">Takip No.&nbsp; </div>
                                                <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn__tracking__number">{object.itemTrackingNumber}</div>
                                            </div> */}
                    <div className="pageWrapper__container__content__itemsWrapper__item__info__resultColumn__forDetail">
                      {object.moves.length > 0 &&
                        object.itemTrackingLink === "" &&
                        object.itemTrackingNumber === "" && (
                          <div
                            onClick={() => togglePanelHandlder(index)}
                            className={`btn-${index} pageWrapper__container__content__itemsWrapper__item__info__resultColumn__forDetail__button`}
                          >
                            Sipariş Takibi <span className="icon"></span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="pageWrapper__deliver-date-wrapper d-lg-down-none">
                    <span className="pageWrapper__deliver-date-title">
                      Planlanan Teslimat Tarihi:
                    </span>
                    <span className="pageWrapper__deliver-date">
                      {object.latestDeliveryDueDate}
                    </span>
                  </div>
                </div>

                {object.itemProductAttribute && (
                  <div className="bottom">
                    <span className="product-components-title">
                      Ürün Özelliği:
                      <span className="show-variant">
                        &nbsp;
                        {size.width > 767 && <span className="icon"></span>}
                      </span>
                    </span>
                    {size.width > 767 && (
                      <span className="product-components-inner">
                        {object.itemProductAttribute}
                      </span>
                    )}
                    {size.width < 767 && (
                      <span className="product-components-inner-mobile">
                        {object.itemProductAttribute}
                      </span>
                    )}
                  </div>
                )}

                <div
                  className={`  pageWrapper__container__content__itemsWrapper__item__detail detail--${index} status--${object.itemStatus.statusIcon} `}
                >
                  {object.moves.map((move) => (
                    <div
                      key={move.moveTitle}
                      className="pageWrapper__container__content__itemsWrapper__item__detail__step"
                    >
                      <div className="pageWrapper__container__content__itemsWrapper__item__detail__circle"></div>
                      <div className="pageWrapper__container__content__itemsWrapper__item__detail__step__infos">
                        <div className="pageWrapper__container__content__itemsWrapper__item__detail__step__state">
                          {move.moveTitle}
                        </div>
                        <div className="pageWrapper__container__content__itemsWrapper__item__detail__step__date">
                          {move.moveDate}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="pageWrapper__container__content__deliveryInfo">
            <div className="pageWrapper__container__content__deliveryInfo__column">
              <div className="pageWrapper__container__content__deliveryInfo__column__title">
                İletişim Bilgileri
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc desc--Bold">
                <img src={mailIcon} alt="Vivense Order Tracking Mail Icon" />
                <span>{customerEmail}</span>
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc desc--Bold">
                <img src={phoneIcon} alt="Vivense Order Tracking Phone Icon" />
                <span>{customerPhoneNumber}</span>
              </div>
            </div>
            <div className="pageWrapper__container__content__deliveryInfo__column">
              <div className="pageWrapper__container__content__deliveryInfo__column__title">
                Teslimat Adresi{" "}
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc desc--Bold">
                {deliveryAdress.adressTitle}
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc">
                {deliveryAdress.adressDesc} <br /> {deliveryAdress.adressRegion}{" "}
              </div>
            </div>
            <div className="pageWrapper__container__content__deliveryInfo__column">
              <div className="pageWrapper__container__content__deliveryInfo__column__title">
                Fatura Adresi
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc desc--Bold">
                {invoiceAdress.adressTitle}
              </div>
              <div className="pageWrapper__container__content__deliveryInfo__column__desc">
                {invoiceAdress.adressDesc} <br /> {invoiceAdress.adressRegion}{" "}
              </div>
            </div>
            <div className="pageWrapper__container__content__deliveryInfo__column">
              <div className="pageWrapper__container__account">
                Daha fazla işlem gerçekleştirebilmek için
                <a href="https://www.vivense.com/vivense-uye-girisi.html">
                  <span> Hesabım </span>
                </a>
                sayfasına giriş yapabilirsin.
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  if (data.fetching === true) {
    return <Loading />;
  }

  if (data.error === true || data.result.status === 404) {
    return <Redirect to="/hata" />;
  }

  return <>{OrderResult()}</>;
};

const mapStateToProps = (state) => {
  return {
    data: state.orderDetailReducer,
  };
};
const mapDisptachToProps = {
  getOrderDetail,
};

export default LoaderHOC(connect(mapStateToProps, mapDisptachToProps)(Detail));
